import { useQuery } from '@tanstack/react-query';

import { fetchChargeCodes } from '../../data-provider/select-options';

export const useGetChargeCodes = () => {
  return useQuery({
    queryFn: () => fetchChargeCodes(),
    queryKey: ['claims-loss-and-damage-charge-codes'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
